import { theme } from 'Assets/Styles/theme'

const styles = {
  wrapper: {
    marginBottom: '24px',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: '8px',
  },

  btnWrapper: {
    display: 'flex',

    '& > div:first-child': {
      marginRight: '16px',
    },
  },
  buttonLabel: {
    fontSize: 16,
    color: theme.colors.primary,
  },
  active: {
    '& > p': {
      color: theme.colors.primary,
    },
  },
  disabled: {
    '& > p': {
      color: '#737373',
    },
  },

  noValue: {
    '& > p': {
      color: '#B6B6B6',
    },
  },

  table: {
    textAlign: 'center',
    borderRadius: '4px',

    '&  p': {
      fontSize: '14px',
    },
  },

  tableContainer: {
    maxHeight: '600px',
  },

  borderRight: {},

  tableHead: {
    background: 'white',
  },
  tableRow: {
    borderBottom: 0,
  },

  tableHeaderCell: {
    width: '100px',
    background: 'white',
    border: 'none',
  },

  firstTableHeaderCell: {
    width: '100px',
    background: 'white',
    border: 'none',
  },

  tableValue: {
    width: '100px',
  },

  outlinedInput: {
    padding: '8px 14px 8px 0',
    textAlign: 'center',
  },

  tableHeadersLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#798498',
    whiteSpace: 'nowrap',
  },

  outlinedNumberInput: {
    padding: '8px 14px 8px 14px',
    textAlign: 'center',

    '& fieldset': {
      border: 'none',
    },
  },

  outlinedInputRoot: {
    width: '124px',
    backgroundColor: '#f8f8f8',
    border: 'none',

    '& fieldset': {
      border: 'none',
    },
  },

  padding10: {
    padding: '4px',
    border: 'none',
  },

  select: {
    height: 30,
    padding: 10,
    borderRadius: 4,
    backgroundColor: '#f8f8f8',
    paddingRight: 20,
    border: 'none',
    '& .MuiSelect-root': {
      backgroundColor: '#f8f8f8',
      width: 200,
      border: 'none',
      paddingLeft: 10,
    },
    '& svg': {
      marginRight: 10,
    },
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 10,
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    height: 44,
    alignItems: 'center',
  },
  addButton: {
    height: 40,
    width: 40,
    marginRight: 10,
    fontSize: 20,
  },
  deleteButtonContainer: {
    cursor: 'pointer',
  },
}

export default styles
